module.exports = __webpack_public_path__ + "static/media/pin0.214ec5e5.svg";